export enum IndentAgainistEnum{
    SALE_ORDER="SALE ORDER",
    DUMMY="DUMMY"
}
export const IndentAgainistEnumdropdown = [
    {name : 'SALE ORDER',value:'SALE ORDER'},{name : 'DUMMY',value:'DUMMY'}
]